import { render, staticRenderFns } from "./MemberFaceApprove.vue?vue&type=template&id=d24a5e54&scoped=true"
import script from "./MemberFaceApprove.vue?vue&type=script&lang=js"
export * from "./MemberFaceApprove.vue?vue&type=script&lang=js"
import style0 from "./MemberFaceApprove.vue?vue&type=style&index=0&id=d24a5e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24a5e54",
  null
  
)

export default component.exports